import React from "react";
import {
  Button, Typography,
} from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import useCloseReceipt from "../../useCloseReceipt";

interface ModalExtendConfirmProps {
  useCustomHook: ReturnType<typeof useCloseReceipt>;
}

const ModalExtendConfirm = ({ useCustomHook }: ModalExtendConfirmProps) => {
  const {
    selectedRows,
    isExtendConfirmModal,
    setExtendConfirmModal,
    dataWhiteReceipt,
    handleExtendReceipt,
  } = useCustomHook;
  return (
    <Modal
      isOpen={isExtendConfirmModal}
      setOpen={setExtendConfirmModal}
      title="Konfirmasi perpanjang masa aktif"
      body={dataWhiteReceipt
        && <Typography level={5}>
          Masa aktif bon akan diperpanjang sampai dengan&nbsp;
          <b>{dataWhiteReceipt.detail_bon_merah?.interval_extend_aging} hari</b>
        </Typography>
      }
      footer={dataWhiteReceipt
        && <>
          <Button
            variant="text"
            onClick={() => setExtendConfirmModal(false)}
          >Batal</Button>
          <Button
            onClick={() => handleExtendReceipt(selectedRows[0].trx_id_bm)}
          >Ya, perpanjang</Button>
        </>
      }
    />
  );
};

export default ModalExtendConfirm;
